import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=68118383&scoped=true"
import script from "./statistics.vue?vue&type=script&lang=ts"
export * from "./statistics.vue?vue&type=script&lang=ts"
import style0 from "./statistics.vue?vue&type=style&index=0&id=68118383&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68118383",
  null
  
)

export default component.exports